export enum SortOptions {
    asc = 'ascending',
    desc = 'descending',
}
